var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeProPic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_24020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 9.50001C3 5.35787 6.35787 2 10.5 2H22.8485C26.9906 2 30.3485 5.35786 30.3485 9.5V23.5909H10.5C6.35786 23.5909 3 20.233 3 16.0909V9.50001Z",
    fill: "#FEFEFE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_24020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 8.72913C21.984 8.79751 21.9645 8.8659 21.9451 8.93428C21.8817 9.1361 21.7703 9.3194 21.6205 9.46833L16.8037 14.2975C16.7422 14.3564 16.6677 14.3999 16.5863 14.4245C15.843 14.6362 15.0964 14.8413 14.3499 15.0497C14.2995 15.0706 14.2441 15.076 14.1907 15.0653C14.1372 15.0546 14.0881 15.0283 14.0496 14.9896C14.011 14.9509 13.9848 14.9017 13.9741 14.848C13.9634 14.7944 13.9688 14.7388 13.9896 14.6883C14.1941 13.9393 14.3986 13.1936 14.6096 12.4512C14.6346 12.3661 14.679 12.288 14.7394 12.2232L19.5464 7.39728C19.6619 7.27146 19.8022 7.17104 19.9583 7.10236C20.1145 7.03367 20.2831 6.9982 20.4536 6.9982C20.6241 6.9982 20.7928 7.03367 20.9489 7.10236C21.1051 7.17104 21.2453 7.27146 21.3608 7.39728C21.3608 7.39728 21.3608 7.39728 21.377 7.39728C21.6921 7.64109 21.9144 7.98589 22.0067 8.37419L22.0002 8.72913ZM19.29 8.45885L15.3107 12.4512L16.5668 13.7081L20.5461 9.71581L19.29 8.45885ZM19.6795 8.03552L20.9778 9.33807C21.0914 9.21433 21.218 9.0971 21.3251 8.96359C21.4158 8.84597 21.4637 8.70074 21.4608 8.55204C21.4578 8.40335 21.4042 8.26014 21.3089 8.14624C21.1882 8.00403 21.0581 7.87021 20.9194 7.74571C20.8557 7.68376 20.7803 7.6351 20.6977 7.60252C20.6151 7.56995 20.5269 7.55411 20.4382 7.55593C20.3495 7.55775 20.262 7.57718 20.1808 7.61311C20.0996 7.64903 20.0263 7.70074 19.9651 7.76525C19.8645 7.84991 19.7736 7.94435 19.6795 8.03552ZM14.6355 14.3952L16.028 14.0077L15.0218 12.9982L14.6355 14.3952Z",
    fill: "url(#paint0_linear_1_24020)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3764 17.9967C12.2563 17.9827 12.1371 17.9621 12.0194 17.9349C11.7304 17.8608 11.474 17.6928 11.2903 17.4572C11.1065 17.2216 11.0056 16.9315 11.0034 16.6323C11.0034 14.2443 11.0034 11.8487 11.0034 9.44553C11.0029 9.26246 11.0391 9.08116 11.1099 8.91242C11.1807 8.74368 11.2846 8.59095 11.4154 8.46334C11.5462 8.33572 11.7013 8.23583 11.8714 8.1696C12.0416 8.10338 12.2232 8.07218 12.4056 8.07786C13.1878 8.07786 13.9733 8.07786 14.7556 8.07786C14.8285 8.06961 14.902 8.08863 14.9619 8.13128C15.0217 8.17393 15.0638 8.23722 15.0801 8.30906C15.0893 8.36988 15.078 8.43203 15.048 8.4857C15.018 8.53936 14.9711 8.58147 14.9146 8.60539C14.8619 8.62563 14.8055 8.6345 14.7491 8.63144H12.4381C12.2724 8.61874 12.1069 8.65757 11.964 8.74264C11.8211 8.82771 11.7078 8.95489 11.6396 9.10687C11.588 9.22835 11.5615 9.35907 11.5617 9.49112C11.5617 11.8552 11.5617 14.2194 11.5617 16.5835C11.5563 16.7008 11.5758 16.8179 11.6189 16.927C11.6621 17.0362 11.728 17.1349 11.8121 17.2165C11.8962 17.2981 11.9967 17.3608 12.1069 17.4005C12.2171 17.4401 12.3344 17.4558 12.451 17.4464H19.9878C20.1938 17.4561 20.3968 17.394 20.5623 17.2706C20.6705 17.1846 20.7565 17.0737 20.813 16.9473C20.8695 16.8209 20.8948 16.6827 20.8869 16.5444V14.2259C20.8825 14.1748 20.8902 14.1234 20.9094 14.0758C20.9286 14.0283 20.9587 13.986 20.9972 13.9523C21.035 13.9232 21.0797 13.9047 21.1269 13.8986C21.1741 13.8925 21.2221 13.899 21.2659 13.9175C21.3098 13.9361 21.348 13.9659 21.3766 14.0041C21.4053 14.0422 21.4233 14.0873 21.4289 14.1347C21.4307 14.1629 21.4307 14.1912 21.4289 14.2194C21.4289 15.0074 21.4289 15.7922 21.4289 16.5802C21.4375 16.8751 21.3499 17.1648 21.1794 17.4052C21.009 17.6456 20.7649 17.8236 20.4844 17.9121C20.3481 17.9503 20.2093 17.9786 20.0689 17.9967H12.3764Z",
    fill: "url(#paint1_linear_1_24020)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_24020",
    x: 0,
    y: 0,
    width: 33.3486,
    height: 27.5909,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.203922 0 0 0 0 0.466667 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_24020"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_24020",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_24020",
    x1: 17.9877,
    y1: 6.9982,
    x2: 17.9877,
    y2: 15.0707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#028FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DC1D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_24020",
    x1: 16.2168,
    y1: 8.07598,
    x2: 16.2168,
    y2: 17.9967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#028FF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0DC1D9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_24020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(11 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeProPic);
export default __webpack_public_path__ + "static/media/changeProPic.1756accba20c6a0b71bb1f6f61c4504c.svg";
export { ForwardRef as ReactComponent };